import React from "react";
import eventTimeline from "./eventTimeline";

export default class CanvasserEventsTimeline extends React.Component {
  static defaultProps = {
    onEventBoxMouseEnter: () => null,
    onEventBoxMouseLeave: () => null,
  };

  constructor(props) {
    super(props);
    this.targetRef = React.createRef();
  }

  componentDidMount() {
    this.timeline = new eventTimeline({
      elem: this.targetRef.current,
      xAccessor: "phone_time",
      keyAccessor: "id",
      timeIncrement: this.props.long ? 60 : 10,
      onEventBoxMouseEnter: this.props.onEventBoxMouseEnter,
      onEventBoxMouseLeave: this.props.onEventBoxMouseLeave,
    }).initiate(this.props.data || []);
  }

  render() {
    return <div ref={this.targetRef} className={"event-timeline-wrapper"} />;
  }
}
